import { render, staticRenderFns } from "./ImportMaterial.vue?vue&type=template&id=72dc9c0c&scoped=true"
import script from "./ImportMaterial.vue?vue&type=script&lang=js"
export * from "./ImportMaterial.vue?vue&type=script&lang=js"
import style0 from "./ImportMaterial.vue?vue&type=style&index=0&id=72dc9c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc9c0c",
  null
  
)

export default component.exports